import React from 'react';
import WallpaperGenerator from './components/WallpaperGenerator';
import './styles/App.css';

const App: React.FC = () => {
  return (
    <div className="App">
      <h1>Goal Wallpaper Generator</h1>
      <div className="footer">
        <p>这个制作壁纸的想法来源于 X 上 <a target='_blank' href="https://x.com/bearbig/status/1877233878538010968?s=46">Bear Liu</a>，感谢他的分享！</p>
      </div>
      <WallpaperGenerator />
    </div>
  );
};

export default App;